import {ReactNode} from 'react';

import {generalNotify} from '@/utils/notifyMessages';

import MHToolTip from '../MHToolTip';

import styles from './mhCopyToClipboard.module.scss';

type MHCopyToClipboardType = {
    icon?: ReactNode;
    toolTipText?: string;
    successMessage?: string;
    children: string | number | ReactNode;
    copyValue?: string | number;
};

export const MHCopyToClipboard = ({icon, successMessage, toolTipText, children, copyValue}: MHCopyToClipboardType) => {
    const handleClick = async () => {
        const textToCopy = copyValue ?? children?.toString?.() ?? '';

        await navigator.clipboard.writeText(textToCopy?.toString?.());

        generalNotify({
            title: 'Success',
            status: 'success',
            message: successMessage ?? 'Copied',
        });
    };

    return (
        <MHToolTip placement="top" tooltipContent={toolTipText || 'Copy'}>
            {icon ? (
                <span className={styles.mhCopyToClipboardIcon} onClick={handleClick}>
                    {icon}
                </span>
            ) : null}
            <span onClick={handleClick} className={styles.mhCopyToClipboardText}>
                {children}
            </span>
        </MHToolTip>
    );
};
